/**
 * Success Page - Shown after successful booking
 */

import { useLocation, useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle2 } from 'lucide-react';

const Success = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const formData = location.state?.formData || {};
  const bookingId = location.state?.bookingId;

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center py-12">
      <div className="container mx-auto px-4 max-w-2xl">
        <Card className="p-8 text-center bg-slate-800/80 border-slate-700 text-white shadow-xl">
          <div className="w-20 h-20 bg-amber-500/20 border border-amber-500/50 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle2 className="w-12 h-12 text-amber-400" />
          </div>
          
          <h1 className="text-3xl font-bold mb-4 text-white">Booking Confirmed!</h1>
          
          <p className="text-slate-400 mb-6">
            Thank you, {formData.firstName}! Your consultation has been scheduled.
          </p>
          
          {bookingId && (
            <p className="text-sm text-slate-500 mb-8">
              Booking ID: {bookingId}
            </p>
          )}
          
          <div className="space-y-4">
            <p className="text-lg text-slate-300">
              We've sent a confirmation email to <strong className="text-amber-400">{formData.email}</strong> with all the details.
            </p>
            
            <p className="text-slate-400">
              Our team will be in touch shortly to prepare for your consultation.
            </p>
          </div>
          
          <Button
            onClick={() => navigate('/')}
            className="mt-8 bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold"
          >
            Return Home
          </Button>
        </Card>
      </div>
    </div>
  );
};

export default Success;
